
export const setupKeyboardShortcuts = () => {
    document.addEventListener('keydown', (event) => {
        // if (event.key === 'g') toggleGrid();
        // if (event.key === 'a') {
        //     const autoRotate = Store.getState().AnimationReducer.autoRotate;
        //     Store.dispatch({ type: 'CAMERA_AUTOMODE', payload: !autoRotate });
        // }
        // if (event.key === 'p') applyOffsetToSelectedToothKeepIndices();
    });
};
